export default __webpack_public_path__ + "static/media/hot_bg1.071dcf45.jpg";